// ── 미팅·추천 지역 위젯 (Mini Row, 2026-06-06 정리) ─────────────────────────
// 사용자 결정:
//   my_meeting_today  → "오늘 N건, 내일 N건" 으로 변경
//   my_meeting_week, my_region_month_visits, my_region_30d_visits 제거
//   my_region_recommended (신규) — 강력추천 등급 1곳, deterministic 랜덤

import React from 'react';
import { Users, Compass, Phone, MapPin } from 'lucide-react';
import { MiniRow } from './MiniRow';

// ── 오늘/내일 미팅 ───────────────────────────────────────────────────────────
// 2 라인 (오늘 N건 / 내일 N건) text-base font-bold. watermark: Phone.
export function MyMeetingTodayMini({ data, accentOverride, sortableId, onClick }) {
  if (!data) return <MiniRow icon={Users} label="오늘/내일" accent="sky" accentOverride={accentOverride} size="S" loading sortableId={sortableId} watermarkIcon={Phone} onClick={onClick} />;
  if (!data.allowed) return <MiniRow icon={Users} label="오늘/내일" accent="sky" accentOverride={accentOverride} size="S" denied sortableId={sortableId} watermarkIcon={Phone} />;
  const today = Number(data.today || 0);
  const tomorrow = Number(data.tomorrowCount || 0);
  return (
    <MiniRow icon={Users} label="오늘/내일" accent="sky" accentOverride={accentOverride} width="narrow" size="S" sortableId={sortableId} watermarkIcon={Phone} onClick={onClick}>
      <span className="flex flex-col items-end gap-1">
        <span className="text-base font-bold text-sky-700 dark:text-sky-300 whitespace-nowrap tabular-nums">
          오늘 {today}건
        </span>
        <span className="text-base font-bold text-sky-600 dark:text-sky-400 whitespace-nowrap tabular-nums">
          내일 {tomorrow}건
        </span>
      </span>
    </MiniRow>
  );
}

// ── 추천 지역 (강력추천 등급 deterministic 랜덤 1곳) ────────────────────────
// 지역명 text-base font-bold. watermark: MapPin.
export function MyRegionRecommendedMini({ data, accentOverride, sortableId, onClick }) {
  if (!data) return <MiniRow icon={Compass} label="추천 지역" accent="blue" accentOverride={accentOverride} size="S" loading sortableId={sortableId} watermarkIcon={MapPin} onClick={onClick} />;
  if (!data.allowed) return <MiniRow icon={Compass} label="추천 지역" accent="blue" accentOverride={accentOverride} size="S" denied sortableId={sortableId} watermarkIcon={MapPin} />;
  const region = data.region;
  if (!region) {
    return (
      <MiniRow icon={Compass} label="추천 지역" accent="slate" accentOverride={accentOverride} width="narrow" size="S" sortableId={sortableId} watermarkIcon={MapPin} onClick={onClick}>
        <span className="text-base font-bold text-[var(--text-muted)]">-</span>
      </MiniRow>
    );
  }
  return (
    <MiniRow icon={Compass} label="추천 지역" accent="blue" accentOverride={accentOverride} width="narrow" size="S" sortableId={sortableId} watermarkIcon={MapPin} onClick={onClick}>
      <span className="text-base font-bold text-blue-700 dark:text-blue-300 whitespace-nowrap">
        {region}
      </span>
    </MiniRow>
  );
}
